class CountdownTimer
{
    constructor(element) {
        this.element = element;

        this.init();
    }

    init() {
        let startTime = this.element.innerHTML;
        let parts = startTime.split(':');
        let hours = parseInt(parts[0]);
        let minutes = parseInt(parts[1]);
        let seconds = parseInt(parts[2]);
        let element = this.element;

        let timer = setInterval(function() {
            let stringHours = hours < 10 ? '0' + hours.toString() : hours.toString();
            let stringMinutes = minutes < 10 ? '0' + minutes.toString() : minutes.toString();
            let stringSeconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();

            element.innerHTML = stringHours + ":" + stringMinutes + ":" + stringSeconds;
            seconds--;

            if (seconds < 0) {
                minutes--;
                seconds = 59;
            }

            if (minutes < 0) {
                hours--;
                minutes = 59;
            }

            if (seconds === 0 && minutes === 0 && hours === 0) {
                clearInterval(timer);

                let parentBlock = element.closest('[data-block="top-offer"]');
                let timerBlock = parentBlock.querySelector('[data-block="timer"]');
                let topButton = parentBlock.querySelector('[data-action="set-top"]');

                topButton.classList.remove('d-none');
                timerBlock.classList.add('d-none');
            }
        }, 1000);
    }
}

export {CountdownTimer};
